import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { SIBreadcrumbs } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import { MANAGEMENT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { MANAGE_CRM_ENRICHMENT_ROUTE, MANAGE_INTEGRATION_ROUTE } from "app/pages/sales-intelligence/constants/sl_routes";
import {
    BREADCRUMB_ENRICHMENT_SETTINGS,
    BREADCRUMB_INTEGRATIONS,
    BREADCRUMB_MANAGE_INTEGRATION,
} from "app/pages/sales-intelligence/common-components/export-table/translations";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { CrmProvider } from "../../types/types";

type EnrichmentSettingsBreadcrumbsProps = {
    crmProvider: CrmProvider;
    dataAutomation: string;
};

export const EnrichmentSettingsBreadcrumbs = ({ crmProvider, dataAutomation }: EnrichmentSettingsBreadcrumbsProps) => {
    const { translate } = useTranslate();

    const breadcrumbs = useMemo(
        () => [
            {
                state: MANAGEMENT_ROUTE,
                title: translate(BREADCRUMB_INTEGRATIONS),
            },
            {
                state: MANAGE_INTEGRATION_ROUTE[crmProvider],
                title: translate(BREADCRUMB_MANAGE_INTEGRATION[crmProvider]),
            },
            {
                state: MANAGE_CRM_ENRICHMENT_ROUTE[crmProvider],
                title: translate(BREADCRUMB_ENRICHMENT_SETTINGS),
            },
        ],
        [crmProvider, translate],
    );

    const handleBreadcrumbClick = ({ state }: { state: string }): void => {
        void proNavigator.go(state);
    };

    return (
        <SIBreadcrumbs
            list={breadcrumbs}
            onClick={handleBreadcrumbClick}
            dataAutomation={dataAutomation}
        />
    );
};
